module.exports = __webpack_public_path__ + "static/media/idCardMx.f0373acd.png";